import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import GoToProcessorPickerButton from 'payments-enrollment-embed-lib/buttons/GoToProcessorPickerButton';
import { useScopes } from 'growth-payments-core/auth/scopes';
import { Screen } from '../../../types/screen';
import { PAYMENT_LINKS_WRITE } from '../../../constants/scopes';
import { PaymentLinksURL } from '../../../utils/paymentUrls';
import { track } from '../../../tracking/track';
import { events } from '../../../tracking/events';
import ModalWrapper from '../ModalWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EnrollInHubSpotPaymentsPaymentLinksModal = ({
  handleInterstitialModalClose,
  screen,
  appName
}) => {
  const scopes = useScopes();
  const hasPaymentLinksWrite = scopes.has(PAYMENT_LINKS_WRITE);
  const Header = /*#__PURE__*/_jsx(Text, {
    as: "h2",
    textAlign: "start",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `embedPoints.enrollInHubSpotPaymentsPaymentLinksModal.generateRevenue.${appName}`
    })
  });
  const Body = /*#__PURE__*/_jsxs(View, {
    as: "div",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "p",
      marginBlockEnd: "300",
      textAlign: "start",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.enrollInHubSpotPaymentsPaymentLinksModal.collectProcessAndReportPayments.paragraph1"
      })
    }), /*#__PURE__*/_jsxs(List, {
      styled: true,
      children: [/*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Text, {
          textAlign: "start",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `embedPoints.enrollInHubSpotPaymentsPaymentLinksModal.collectProcessAndReportPayments.bullets.bullet1.${appName}`
          })
        })
      }, "bullet1"), [2, 3].map(bulletPoint => /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Text, {
          textAlign: "start",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `embedPoints.enrollInHubSpotPaymentsPaymentLinksModal.collectProcessAndReportPayments.bullets.bullet${bulletPoint}`
          })
        })
      }, bulletPoint))]
    })]
  });
  const Footer = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(GoToProcessorPickerButton, {
      use: "primary",
      external: true,
      openInCommerceHome: true,
      sourceApp: screen,
      location: "embed-point-pre-enroll-modal",
      block: screen !== Screen.MEETINGS
    }), screen === Screen.MEETINGS && /*#__PURE__*/_jsx(Button, {
      "data-test-id": "createTestPaymentLinkButton",
      use: "secondary",
      rel: "noopener" // override the rel attribute to remove the "noreferrer" tag, slack ref - https://hubspot.slack.com/archives/CEZNHE030/p1696003611704799
      ,
      disabled: !hasPaymentLinksWrite,
      external: true,
      href: PaymentLinksURL,
      onClick: () => track(events.paymentsInterstitialModalInteraction, {
        action: 'click',
        screen,
        value: 'createTestPaymentLink'
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.ctas.managePaymentLinks"
      })
    })]
  });
  return /*#__PURE__*/_jsx(ModalWrapper, {
    Body: Body,
    Footer: Footer,
    Header: Header,
    modalSubTitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "embedPoints.enrollInHubSpotPaymentsPaymentLinksModal.enrollInHubSpotPayments"
    }),
    modalName: "enrollInHubSpotPaymentsPaymentLinksModal",
    onClose: handleInterstitialModalClose,
    illustrationName: "payments"
    // These IDs are consumed in ContentUILib tests here - https://git.hubteam.com/HubSpot/ContentUILib/blob/38070682659bc044d69d191f7ab8995844129907/ContentComponents/static/test/spec/components/PaymentField.test.tsx#L86-L94
    ,
    modalDataTestId: "enroll-payment-links-modal",
    closeButtonDataTestId: "enroll-payment-links-close-button",
    paddingBlock: "1000",
    paddingInlineEnd: "1000"
  });
};
export default EnrollInHubSpotPaymentsPaymentLinksModal;